import React from "react";

import './main.css';

const data = [
    {
        title: 'Из чего состоит ПВХ окно?',
        paragraph: 'Купить окна ПВХ в Челябинске можно с профилем трех типов: Пластиковый. Практичный, герметичный и долговечный профиль с широкими возможностями декоративного оформления (оттенок, ламинация). Цены на окна ПВХ являются вполне доступными; Алюминиевый. Легкий, прочный и недорогой профиль, основной его недостаток – плохая теплоизоляция; Деревянный. Дорогие качественные рамы, изготавливаются в основном из натурального массива сосны, дуба или лиственницы.'
    },
    {
        title: 'Какие бывают окна по типу профиля?',
        paragraph: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Eveniet natus sint provident vel ab reprehenderit cum soluta, suscipit facere nisi sed earum repellendus fuga debitis, nam molestiae minima voluptates possimus.Lorem ipsum dolor sit amet consectetur adipisicing elit. Eveniet natus sint provident vel ab reprehenderit cum soluta, suscipit facere nisi sed earum repellendus fuga debitis, nam molestiae minima voluptates possimus.'
    },
    {
        title: 'Как выбрать окно по типу стеклопакета?',
        paragraph: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Eveniet natus sint provident vel ab reprehenderit cum soluta, suscipit facere nisi sed earum repellendus fuga debitis, nam molestiae minima voluptates possimus.Lorem ipsum dolor sit amet consectetur adipisicing elit. Eveniet natus sint provident vel ab reprehenderit cum soluta, suscipit facere nisi sed earum repellendus fuga debitis, nam molestiae minima voluptates possimus.'
    },
    {
        title: 'Как заказать качественное пластиковое окно?',
        paragraph: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Eveniet natus sint provident vel ab reprehenderit cum soluta, suscipit facere nisi sed earum repellendus fuga debitis, namLorem ipsum dolor sit amet consectetur adipisicing elit. Eveniet natus sint provident vel ab reprehenderit cum soluta, suscipit facere nisi sed earum repellendus fuga debitis, nam molestiae minima voluptates possimus.'
    }
]


export default function FAQ() {
    
    return (
        <>
            <div className="faq">
                <div className="theme-faq"></div>
                <div className="faq-container">
                    <h1>Частые вопросы</h1>
                    <div className="faq-header">
                        <div {...{ className: 'wrapper' }}>
                            <ul {...{ className: 'accordion-list' }}>
                                {data.map((data, key) => {
                                    return (
                                        <li {...{ className: 'accordion-list__item', key }}>
                                            <AccordionItem {...data} />
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

class AccordionItem extends React.Component {
    state = {
        opened: false
    }

    render() {
        const {
            props: {
                paragraph,
                title
            },
            state: {
                opened
            }
        } = this

        return (
            <div
                {...{
                    className: `accordion-item, ${opened && 'accordion-item--opened'}`,
                    onClick: () => { this.setState({ opened: !opened }) }
                }}
            >
                <div {...{ className: 'accordion-item__line' }}>
                    <h3 {...{ className: 'accordion-item__title' }}>
                        {title}
                    </h3>
                    <span {...{ className: 'accordion-item__icon' }} />
                </div>
                <div {...{ className: 'accordion-item__inner' }}>
                    <div {...{ className: 'accordion-item__content' }}>
                        <p {...{ className: 'accordion-item__paragraph' }}>
                            {paragraph}
                        </p>
                    </div>
                </div>
            </div>
        )
    }
}